module.exports = __webpack_public_path__ + "static/media/login_dark.aef8d370.png";